<template>
  <div class="modal-cover" @click="onClose" v-if="!isLeaved">
    <div class="block-member-container" @click.stop>
      <div class="block-member-header-container">
        <button class="close-modal" @click="onClose"></button>
        <div>{{ $t('camstudy.blockMember.title') }}</div>
        <div class="add-block-member"></div>
      </div>
      <ul class="block-member-body-container">
        <li class="block-member-item"
            v-for="banUser in banUserList" :key="banUser.banId"
        >
          <div class="flex items-center gap-3">
            <img v-if="getCamStudyUser(banUser.userId)?.profileImageUrl" :src="getCamStudyUser(banUser.userId)?.profileImageUrl" :alt="$t('camstudy.blockMember.user')" class="user-image" />
            <div v-else class="user-image none"></div>
            <div class="user-email">{{ maskingEmail(banUser.email )}}</div>
          </div>
          <button class="unblock-button" @click="reqRemoveBanUser(banUser)">{{ $t('camstudy.blockMember.unblock') }}</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'CamstudyBlockMemberModal',
  computed: {
    ...mapGetters('user', [
        'hasEmceeRole'
    ]),
    ...mapGetters('camstudy',[
        'banUserList',
        'getCamStudyUser'
    ]),
    ...mapGetters('room', [
      'isLeaved',
    ]),
  },
  methods: {
    ...mapActions('camstudy', [
        'removeCamStudyUserBan',
    ]),
    onClose() {
      this.$modal('CamstudyBlockMemberModal', {once: true})
    },
    reqRemoveBanUser(banUser) {
      if(!this.hasEmceeRole()) return

      this.$camsAlert({
        text: this.$t('camstudy.blockMember.confirmUnblock'),
        ok: () => {
          this.removeCamStudyUserBan({email: banUser.email})
        }
      })

    },
    maskingEmail(email) {
      if (!email || !email.includes('@')) {
        return email;
      }
      const [localPart, domain] = email.split('@');
      if (localPart.length <= 2) {
        return localPart.charAt(0) + '*' + '@' + domain;
      } else {
        return localPart.charAt(0) + '*'.repeat(localPart.length - 2)
            + localPart.charAt(localPart.length - 1)
            + '@' + domain;
      }
    }
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile] {
  .modal-cover {
    background-color: rgba(0, 0, 0, 0.5);
    @media(orientation: portrait) {
      left: 0;
      right: 0;
      bottom: 64px;
    }
    @media(orientation: landscape) {
      left: env(safe-area-inset-left);
      right: env(safe-area-inset-right);
      bottom: 98px;
      z-index: 99;
    }
    .block-member-container {
      @media(orientation: portrait) {
        bottom: 0;
        left: 0;
        width: 100%;
        .block-member-body-container {
          height: 331px;
        }
      }
      @media(orientation: landscape) {
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        .block-member-body-container {
          height: calc(100% - 44px);
        }
      }
    }
  }
}
html:not([grm-device-mobile]) {
  .modal-cover {
    left: 0;
    right: 0;
    bottom: 80px;
    top: 0;
    .block-member-container {
      bottom: -80px;
      top: 0;
      right: 0;
      width: 360px;

      .block-member-body-container {
        height: calc(100% - 44px);
      }
      border-left: 0.5px solid rgba(255, 255, 255, 0.20);
      background: #1A1A1A;
    }
  }
}
.modal-cover{
  position: fixed;
  top: 0;
  z-index: 2;
}
.block-member-container {
  position: absolute;
  line-height: 1.5;
  background: #1F1F1F;
  color: white;
  z-index: 100;

  .block-member-header-container {
    display: flex;
    padding: 6px 16px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
  }

  .block-member-body-container {
    padding: 12px 0;

    &::-webkit-scrollbar {
      display: none;
    }

    .block-member-item{
      display: flex;
      padding: 12px 20px;
      justify-content: space-between;
      align-items: center;

      .user-image{
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: #D9D9D9;
        &.none {
          background: url("~@/assets/images/user_profile.svg") no-repeat;
          background-size: auto 24px;
        }
      }
      .user-email{
        color: #FFF;
        font-size: 14px;
      }
    }
    .unblock-button{
      padding: 4px 8px;
      border-radius: 6px;
      background: #393939;
      color: #FFF;
      font-size: 12px;
    }
  }

  .close-modal {
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_close_white.svg") center no-repeat;
    background-size: auto 24px;
  }

  .add-block-member {
    width: 32px;
    height: 32px;
    color: #016FF2;
    font-size: 14px;
    display: flex;
    align-items: center;
  }
}
</style>